const path = window.location.pathname;

export const BASE_PATH =
  path === '/momenta' || path.startsWith('/momenta/')
    ? '/momenta'
    : '';
